import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux-tool-kit/Hooks';
import { Image, SVG } from '../../AbstractElements';
import { setToggleSidebar } from '../../redux-tool-kit/reducers/LayoutSlice';
import { dynamicImage } from '../../service';

const LogoWrapper = () => {
    const dispatch = useAppDispatch();
    const {toggleSidebar} = useAppSelector((state)=>state.layout)

    return (
      <>
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
            <Image className="img-fluid" src={dynamicImage("dashboard-8/dark-logo.png")} alt="logo" style={{height:"60px"}}/>
          </Link>
          <div className="toggle-sidebar">
            <SVG className={`sidebar-toggle`} iconId={`toggle-icon`} onClick={()=>dispatch(setToggleSidebar(!toggleSidebar))}/>
          </div>
        </div>
        <div className="logo-icon-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
            <Image className="img-fluid" src={dynamicImage("logo/logo-icon.png")} alt="logo" />
          </Link>
        </div>
      </>
    );
}

export default LogoWrapper